"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpIcon = exports.QuestionCircleIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** QuestionCircleIcon */
var QuestionCircleIcon = function QuestionCircleIcon(props) {
  return _react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 18 18"
  }), _react.default.createElement("title", null, "Help"), _react.default.createElement("path", {
    d: "M9 1.889A7.111 7.111 0 1 1 9 16.11 7.111 7.111 0 0 1 9 1.89zM9 1a8 8 0 1 0 0 16A8 8 0 0 0 9 1zm-.658 9.92v-.142c0-1.111.214-1.458 1.307-2.418.405-.294.66-.753.693-1.253a1.182 1.182 0 0 0-1.298-1.254 1.422 1.422 0 0 0-1.448 1.6H6.573a2.391 2.391 0 0 1 2.534-2.4 2.089 2.089 0 0 1 2.32 2c0 1.716-2.143 2.01-2.143 3.69v.177h-.942zm-.089 2.027V11.8H9.41v1.147H8.253z",
    fill: (0, _helpers.color)(props.fill),
    fillRule: "nonzero"
  }));
};

exports.QuestionCircleIcon = QuestionCircleIcon;
QuestionCircleIcon.displayName = "QuestionCircleIcon";
// TODO: remove this alias once clients have been updated
var HelpIcon = QuestionCircleIcon;
exports.HelpIcon = HelpIcon;
//# sourceMappingURL=QuestionCircleIcon.js.map